import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import "@/index.css";
import App from "@/App";
import SetupNotice from "@/pages/SetupNotice";

const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
const isValidClerkKey =
  typeof clerkPublishableKey === "string" &&
  (clerkPublishableKey.startsWith("pk_test_") ||
    clerkPublishableKey.startsWith("pk_live_")) &&
  !clerkPublishableKey.includes("REPLACE");

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {isValidClerkKey ? (
      <ClerkProvider
        publishableKey={clerkPublishableKey}
        signInUrl="/login"
        signUpUrl="/signup"
        afterSignOutUrl="/login"
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ClerkProvider>
    ) : (
      <SetupNotice />
    )}
  </React.StrictMode>
);
